import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Gesture, GestureController } from '@ionic/angular';

type TPullupStateOpts = "full" | "mid" | "min"
type TPullupActionOpts = "onStart" | "onMove" | "OnEnd" | "non"

const _safeAreaBottom: any = () => getComputedStyle(document.documentElement).getPropertyValue('--ion-safe-area-bottom')
const _safeAreaTop: any = () => getComputedStyle(document.documentElement).getPropertyValue('--ion-safe-area-top')

export interface IPullupStateChangeModel {
  currentState: TPullupStateOpts
  previousState: TPullupStateOpts
}

@Component({
  selector: 'app-pullup-footer',
  templateUrl: './pullup-footer.component.html',
  styleUrls: ['./pullup-footer.component.scss'],
})
export class PullupFooterComponent implements OnInit {
  @ViewChild('pullupHandler') pullupHandler: ElementRef
  @ViewChild('mainContainer') mainContainer: ElementRef

  /**
   * onStart, onMove, OnEnd
   */
  @Input() movingActionPermissions: TPullupActionOpts[] = []
  @Input() startPosition: TPullupStateOpts = "mid"

  @Input() availableLevels: TPullupStateOpts[] = []

  @Input() set updatePullupState(state: TPullupStateOpts) {
    if (state && this.mainContainer && this.mainContainer.nativeElement)
      switch (state) {
        case "full":
          this.mainContainer.nativeElement.style.height = 'calc(98vh - 83px - ' + (2 * (this.safeAreaBottom)) + "px )"
          break;
        case "mid":
        case "min":
          this.mainContainer.nativeElement.style.height = 'unset'
          break;
        default:
          break;
      }
  }
  @Output() pullupStateChange: EventEmitter<IPullupStateChangeModel> = new EventEmitter()

  private previousState: TPullupStateOpts

  private _pullupState: TPullupStateOpts = "mid";
  public get pullupState(): TPullupStateOpts {
    return this._pullupState;
  }
  public set pullupState(value: TPullupStateOpts) {
    this.previousState = this._pullupState
    this._pullupState = value;
    this.pullupStateChange.emit({ currentState: value, previousState: this.previousState })
  }
  private mainContainerLastHeight: number

  private _safeAreaTop: number = 0;
  public get safeAreaTop(): number {
    try {
      let safeAreaTop = +_safeAreaTop().replace("px", "")
      return !isNaN(safeAreaTop) ? safeAreaTop : 0;
    } catch (error) {
      return 0;
    }
  }
  private _safeAreaBottom: number = 0;
  public get safeAreaBottom(): number {
    try {
      let safeAreaBottom = +_safeAreaBottom().replace("px", "")
      return !isNaN(safeAreaBottom) ? safeAreaBottom : 0;
    } catch (error) {
      return 0;
    }
  }
  gesture: Gesture;
  constructor(private gestureCtrl: GestureController) { }

  ngOnInit() {
    this.pullupState = this.startPosition;
    this.initGesture()
  }

  initGesture() {
    if (this.pullupHandler && this.pullupHandler.nativeElement) {
      this.gesture = this.gestureCtrl.create({
        el: this.pullupHandler.nativeElement,
        threshold: 10,
        direction: 'y',
        // canStart: (ev) => {
        //   return !this.isFullscreen
        // },
        onStart: (ev) => {
          if (this.CheckForAction("onStart")) {
            this.mainContainerLastHeight = this.mainContainer.nativeElement.clientHeight;
          }
        },
        onMove: (ev) => {
          if (this.CheckForAction("oMove")) {
            if (this.pullupState !== 'full')
              this.mainContainer.nativeElement.style.height = `${this.mainContainerLastHeight - ev.deltaY}px`
            else {
              if (ev.deltaY > 0)
                this.mainContainer.nativeElement.style.height = `${this.mainContainerLastHeight - ev.deltaY}px`
            }
          }
        },
        onEnd: (ev) => {
          if (this.CheckForAction("onEnd")) {
            // if (!this.isFullscreen) {
            //TODO buraya bakılacak
            // let height = this.mainContainer.nativeElement.clientHeight
            // let deviceHeight = window.innerHeight
            if (this.pullupState === 'full') {
              if (ev.deltaY > 0) {
                this.pullupState = 'mid'
                this.mainContainer.nativeElement.style.height = 'unset'
                // this.mainContainer.nativeElement.style.height = 'unset'
              }
            } else if (this.pullupState === 'mid') {
              if (ev.deltaY < 0) {
                this.pullupState = 'full'
                this.mainContainer.nativeElement.style.height = 'calc(98vh - 83px - ' + (2 * (this.safeAreaBottom)) + "px )"
              } else {
                this.pullupState = 'min'
                this.mainContainer.nativeElement.style.height = 'unset'
              }
            } else if (this.pullupState === 'min') {
              if (ev.deltaY > 0) {
                this.pullupState = 'min'
                this.mainContainer.nativeElement.style.height = 'unset'
              } else {
                this.pullupState = 'mid'
                this.mainContainer.nativeElement.style.height = 'unset'
              }
            } else {
              this.mainContainer.nativeElement.style.height = 'unset'
            }
            // }
          }
        },
        gestureName: 'pullupHandler',

      })
      this.gesture.enable()
      return
    } else {
      setTimeout(() => {
        return this.initGesture()
      }, 1000);
    }
  }


  private CheckForAction(prop): boolean {
    if (Array.isArray(this.movingActionPermissions) && this.movingActionPermissions.length > 0) {
      return this.movingActionPermissions.some(t => t == prop)
    } else {
      return true;
    }
  }


  toggleFullscreen() {
    if (this.CheckForAction("onMove")) {
      this.pullupState = this.pullupState === "full" ? this.previousState : "full"
      // this.pullupState = this.isFullscreen ? 'full' : 'mid'
      this.mainContainer.nativeElement.style.height = this.pullupState === 'full' ? 'calc(98vh - 83px - ' + (2 * (this.safeAreaBottom)) + "px )" : 'unset'
    }
  }
}
